import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import ConsumerLayout from '../consumer-layout/ConsumerLayout';
import Header from './components/header/Header';
import { resetResonanceProject, selectResonanceTab } from '../../redux/resonance/resonanceReducer';
import MessageResponse from '../../resonance/components/message-response/MessageResponse';
import Benchmarks from '../../resonance/components/benchmarks/Benchmarks';
import CommonTabs from '../../components/common-tabs/CommonTabs';
import CommonTabPanel from '../../components/common-tabs/CommonTabPanel';
import { getConsumerResonanceInitData } from '../../redux/consumer/resonance/consumerResonanceActions';
import ConceptResponse from '../../resonance/components/concept-response/ConceptResponse';
import useResonanceTabs from '../../resonance/hooks/useResonanceTabs';
import { PROJECT_TYPES, PROJECT_VARIANTS } from '../../constants';
import { ProjectProvider } from '../../context/ProjectContext';

import scss from './Resonance.module.scss';

function Resonance() {
  const dispatch = useDispatch();
  const { t } = useTranslation('resonance');

  const selectedTab = useSelector((state) => state.resonance.selectedTab);

  const TABS = useResonanceTabs();

  const handleChangeTab = (_, newTab) => {
    dispatch(selectResonanceTab(newTab));
  };

  useEffect(() => {
    dispatch(getConsumerResonanceInitData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      dispatch(resetResonanceProject());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ConsumerLayout Header={Header()}>
      <ProjectProvider projectVariant={PROJECT_VARIANTS.CONSUMER} projectType={PROJECT_TYPES.RESONANCE}>
        <CommonTabs tabs={TABS} value={selectedTab} onChange={handleChangeTab} isFullWidth />

        <CommonTabPanel value={selectedTab} index={0} className={scss.tabPanel}>
          {t('backgroundData')}
        </CommonTabPanel>

        <CommonTabPanel value={selectedTab} index={1} className={scss.tabPanel}>
          <MessageResponse />
        </CommonTabPanel>

        <CommonTabPanel value={selectedTab} index={2} className={scss.tabPanel}>
          <ConceptResponse />
        </CommonTabPanel>

        <CommonTabPanel value={selectedTab} index={3}>
          <Benchmarks />
        </CommonTabPanel>
      </ProjectProvider>
    </ConsumerLayout>
  );
}

export default Resonance;
